import { render, staticRenderFns } from "./landing-page-quarter-section.vue?vue&type=template&id=37db8ef1&scoped=true&lang=pug"
import script from "./landing-page-quarter-section.js?vue&type=script&lang=js&external"
export * from "./landing-page-quarter-section.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-quarter-section.vue?vue&type=style&index=0&id=37db8ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37db8ef1",
  null
  
)

export default component.exports